// extracted by mini-css-extract-plugin
export default {"add_card_btn":"styles_add_card_btn__p6VG9","svg_wrapper":"styles_svg_wrapper__JS0Rd","btn_plus_icon":"styles_btn_plus_icon__mwaee"};